<template>
  <div class="pass" :class="passed ? 'pass-success' : 'pass-fail'">
    <div class="pass-content">
      <p class="pass-content-score">{{ score }}<span class="text-normal">分</span></p>
      <p>{{ passed ? '考试通过' : '考试未通过' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      required: true
    },
    passed: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.pass {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  opacity: .7;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 5%;
    top: 5%;
    width: 90%;
    height: 90%;
    border-radius: 50%;
  }

  &-content {
    position: absolute;
    width: 60%;
    left: 50%;
    top: 50%;
    text-align: center;
    transform: translate(-50%, -50%);

    &-score {
      font-size: 35px;
      margin-bottom: 5px;
      line-height: 1.5;
      font-weight: 300;
    }
  }

  &-success {
    color: #e0a970;
    border: 3px solid #e0a970;
    &:before {
      border: 2px solid #e0a970;
    }
    .pass-content-score {
      border-bottom: 1px solid #e0a970;
    }
  }
  &-fail {
    color: #ed4014;
    border: 3px solid #ed4014;
    &:before {
      border: 2px solid #ed4014;
    }
    .pass-content-score {
      border-bottom: 1px solid #ed4014;
    }
  }
}
</style>
